export enum TransferInitiatorEnum {
    client = 1,
    performer = 2
}
